import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import styles from './JoinOurTeam.module.scss';

import { Button } from '../Buttons';
import { H2, P3 } from '../Typography';

export const JoinOurTeam = () => {
  const { t } = useTranslation('index', { keyPrefix: 'about' });
  return (
    <div className={styles.join}>
      <H2>{t('joinOurTeam')}</H2>
      <P3>{t('weExpectCollegues')}</P3>
      <Button
        label={t('viewVacancies')}
        theme="light-invert"
        size="lg"
        as="a"
        target="_blank"
        href="https://villacarte.peopleforce.io/careers"
        className={styles.join__button}
      />
      <Image
        // sizes="600px"
        src={'/leaves/about-leaves.webp'}
        sizes="(min-width: 680px) 600px, 92.22vw"
        width={600}
        height={240}
        alt=""
        className={styles.join__leaves}
      />
    </div>
  );
};
